
import { widgetWrapper } from './wrapper/WidgetWrapper'
import { translateService } from './service/TranslateService'
import { installService } from './service/InstallService'
import qs from 'qs'
import { setCookie } from './utils'

window.addEventListener('DOMContentLoaded', async () => {

	const container = document.querySelector('#google-translate')
	const metaparams = container.querySelector('[data-google-translate-params]')
	const params = JSON.parse(metaparams.dataset.googleTranslateParams)

	installService.setParams(params)
	translateService.setParams(params)
	widgetWrapper
		.setContainer(container)
		.setParams(params)
		.render()

	const query = qs.parse(window.location.search, {ignoreQueryPrefix: true})
	const queryLang = query.lang
	let cookieLang = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)')
	cookieLang = cookieLang ? cookieLang[2].split('/')[2] : null
	const activeLang = queryLang || cookieLang || null

	if(activeLang) {		
		setCookie('googtrans', `/pl/${activeLang}`)
		translateService.autoTranslate(500, activeLang)
	}	
})




// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googletranslate/script.js